import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { Input } from 'antd';
import {
  authenticate,
  clearPasswordRejection,
} from 'modules/auth/slices/authSlice';
import SubmitButton from 'components/buttons/SubmitButton/SubmitButton';
import InputForm from 'components/InputForm/InputForm';

import styles from './login.module.less';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hash = '' } = useParams();
  const { auth } = useSelector((state: any) => state);

  const { benguideError = {} } = auth;
  // UAT-3257 — the message now comes from the auth failure itself. It used to
  // come from `showErrorMessage`, which this component set the moment Login
  // was pressed (so it could appear for a password that turned out to be
  // correct) and which the next attempt's `authenticateInprogress` cleared.
  const { authFailed, invalidPassword } = benguideError || {};
  const { error, inProgress } = auth;
  const [credentials, setCredentials] = useState({
    password: '',
  });

  useEffect(() => {
    const { inProgress } = auth;
    if (!(inProgress || authFailed)) {
      navigate('./..');
    }
  }, [authFailed, auth, navigate]);

  const loginHandler = () => {
    // Nothing is marked wrong here any more: the thunk says so if and when the
    // server refuses.
    dispatch(
      authenticate(hash, {
        mode: 'PUBLISHED',
        password: credentials.password,
      })
    );
  };

  const textChangeHandler = (event: any) => {
    const { value, name } = event.target;
    setCredentials({ ...credentials, [name]: value });
    dispatch(clearPasswordRejection());
  };

  return (
    <div className={styles.loginWrapper}>
      <div className={styles.loginHeader}>Login</div>
      <div> Password :</div>
      <InputForm layout="vertical" onFinish={loginHandler}>
        <div>
          <Input.Password
            className={`${styles.passwordField} ${
              invalidPassword ? styles.invalid : ''
            }`}
            name="password"
            value={credentials.password}
            onChange={textChangeHandler}
          />
        </div>
        {invalidPassword && (
          <div className={styles.invalidCredentials}>
            Incorrect password. Please check it and try again.
          </div>
        )}
        <SubmitButton
          onClick={loginHandler}
          loading={inProgress}
          disabled={isEmpty(credentials.password) || inProgress}
        >
          Login
        </SubmitButton>
        {error && <div>Authentication Failed</div>}
      </InputForm>
    </div>
  );
};

export default Login;
